@use '@flixbus/honeycomb-react/dist/scss/honeycomb-helpers.scss';

.container {
  display: flex;
  align-items: center;
  gap: var(--hcr-spacing-2);
}

.label {
  font-size: var(--hcr-font-size-primary);
  line-height: var(--hcr-line-height-primary);
  color: var(--hcr-content-secondary-color);
  white-space: nowrap;
}

.tabs {
  margin: 0;
}

.emptyValues {
  font-size: var(--hcr-font-size-primary);
  line-height: var(--hcr-line-height-primary);
  color: var(--hcr-content-secondary-color);
}
